import React, { Component } from 'react';
import IconInput from '../../components/icon-input';
import { Link, withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import './styles.css';



class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async login() {
    event.preventDefault();

    if (!this.state.email || !this.state.password) {
      return alert('Please enter an email and password');
    }
    // AWS Cognito integration here
    try {
      await Auth.signIn(this.state.email, this.state.password);
      // redirect to dashboard. user is authenticated
      this.props.auth.setAuthStatus(true);
      this.props.history.push('/dashboard');
    } catch (e) {
      alert(e.message);
    }
  } //login

  render() {
    return (
      <div className='d-flex h-100 justify-content-center background-image'>
        <div className='align-self-md-center h-auto w-40 p-4 form-container '>
          <p className='login-title'>LOG INTO ENERGIZE</p>
          <form onSubmit={() => this.login()} autoComplete='on'>
            <IconInput icon='fa fa-envelope' autoComplete='on' placeholder='ENTER EMAIL' type='text' value={this.state.email} onChange={(input) => this.setState({ email: input.toLowerCase() })} />
            <IconInput icon='fa fa-lock' autoComplete='on' placeholder='PASSWORD' type='password' value={this.state.password} onChange={(input) => this.setState({ password: input })} secureTextEntry={true} />

            <input className='btn btn-info btn-block font-weight-bold' type="submit" value="SUBMIT" />
          </form>

          <Link to='/signup' className=' btn btn-link btn-block font-weight-bold link'>NEW USER? SIGNUP HERE</Link>
          {/* forgot password webpage link */}
          <Link to='/forgotpassword' className=' btn btn-link btn-block font-weight-bold link'>FORGOT PASSWORD? CLICK HERE</Link>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/routes/login/index.js